<template>
<div>
  <form action="/">
    <van-search v-model="value" show-action placeholder="请输入搜索关键词" @search="onSearch">
      <template slot="action">
        <div @click="onSearch">搜索</div>
      </template>
    </van-search>
  </form>

  <div v-if="!searchInfoBtn">
    <van-empty description="请输入您要搜索的车辆信息"></van-empty>
  </div>
  <div v-else-if="searchInfoBtn && chetouItems.length>0">
    <van-cell v-for="item in chetouItems" :key="item.id" :title="item.chetouhao" @click="chooseChetou" />
  </div>
  <div v-if="searchInfoBtn && chetouItems.length<=0">
    <van-empty description="未搜索到您想要的信息，是否选择新增车辆？">
    <div class="add-btn-box">
      <van-button round type="danger" block class="bottom-button" @click="addChetouVehicle">新 增 车 辆</van-button>
    </div>
    </van-empty>
  </div>
  <Tabbar></Tabbar>
</div>
</template>

<script>
import Tabbar from "@/views/Public/tabbarTpl.vue"
import { Toast } from 'vant';
import api from '@/fetch/api';

export default {
  components:{
    Tabbar
  },
  created: function() {
    document.title = "搜索车头信息";
  },
  data() {
    return {
      value: '',
      chetouItems: [],
      searchInfoBtn:false,
    };
  },
  methods: {
    chooseChetou(e) {
      var chetouhao = e.currentTarget.innerText;
      if (chetouhao.length > 0) {
        sessionStorage.setItem('chetouhao', chetouhao);
        this.$router.push({
          name: 'addAllCar'
        });
      }
    },
    onSearch() {
      var that = this;
      var search = that.value;
      if (search.length == 0) {
        Toast('查询的内容不能为空');
      } else {
        api.searchChetou(search).then(function(resData) {
          that.value = "";
          var res = JSON.parse(resData);
          if (res.respCode == 0) {
            that.chetouItems = res.data;
            that.searchInfoBtn = true;
          }
        }).catch(function(err) {
          console.log(err);
        });
      }
    },
    onCancel() {
      this.searchInfoBtn = false;
    },
    addChetouVehicle()
    {
      this.$router.push({
        name: 'addchetou'
      })
    },

  },
};
</script>
<style lang="scss" scoped>

</style>
